import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { FeaturedMasterclasses } from './components/FeaturedMasterclasses';
import { WhyPeopleBook } from './components/WhyPeopleBook';
import { Founder } from './components/Founder';
import { PrivateMasterclasses } from './components/PrivateMasterclasses';
import { MakeupServices } from './components/MakeupServices';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-parchment text-ink font-sans selection:bg-copper selection:text-white pb-16 lg:pb-0" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <FeaturedMasterclasses data-id="element-5" />
        <SocialProof data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <WhyPeopleBook data-id="element-8" />
        <Founder data-id="element-9" />
        <PrivateMasterclasses data-id="element-10" />
        <MakeupServices data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <ContactForm data-id="element-14" />
      </main>
      <Footer data-id="element-15" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-16">
        {showStickyCTA && <motion.div initial={{
        y: 100
      }} animate={{
        y: 0
      }} exit={{
        y: 100
      }} transition={{
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-ink text-parchment py-4 px-6 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]" data-id="element-17">
            <a href="#masterclasses" className="block w-full text-center text-xs uppercase tracking-[0.2em] font-semibold" data-id="element-18">
              Book a Masterclass
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}